import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useDeps } from '@Contexts/DI';
import { useRequest } from '@Contexts/Request';
import getSurveys from '@Api/Site/getSurveys';

const useSurveys = () => {
  const { logger } = useDeps();
  const { region } = useRequest();

  const key = ['surveys', region];

  const handleGetSurveys = useCallback(async () => {
    try {
      const surveys = await getSurveys();

      return surveys;
    } catch (error) {
      logger.error(error);
    }
  }, [logger]);

  const query = useQuery({
    queryKey: key,
    queryFn: handleGetSurveys,
  });

  return query;
};

export default useSurveys;
